<div class="hospital-site-selector">
  <!-- SELECT EXISTING SITE MODE -->
  <div *ngIf="mode === 'select' && !confirmationMessage">
    <h2 class="dialog-title">
      <mat-icon class="title-icon">business</mat-icon>
      Select or Add Hospital Site
    </h2>
    <p class="dialog-subtitle">Please select from your available hospital(s) or request access to an additional hospital. You will not be able to access the additional hospital's dashboard until your request has been approved by hospital leadership.</p>

    <div class="sites-section">
      <label class="section-label">Your Hospital Sites</label>
      <div class="sites-list">
        <div
          *ngFor="let site of grantedSites"
          class="site-item"
          [class.selected]="selectedCode === site.hospitalCode"
          (click)="selectSite(site)">
          <span class="site-name">{{ site.practiceName || site.hospitalCode }}</span>
          <span class="site-code">{{ site.hospitalCode }}</span>
        </div>
      </div>
    </div>

    <button
      class="add-new-btn"
      (click)="showAddNew()">
      + Request Additional Hospital Site
    </button>

    <button
      class="confirm-btn"
      [disabled]="!selectedCode"
      (click)="confirmExistingSite()">
      Confirm Site
    </button>
  </div>

  <!-- ADD NEW SITE MODE -->
  <div *ngIf="mode === 'add' && !confirmationMessage">
    <h2 class="dialog-title">
      <mat-icon class="title-icon">business</mat-icon>
      Select or Add Hospital Site
    </h2>
    <p class="dialog-subtitle">Please select from your available hospital(s) or request access to an additional hospital. You will not be able to access the additional hospital's dashboard until your request has been approved by hospital leadership.</p>

    <div class="search-section">
      <label class="section-label">Search for Hospital Site</label>
      <div class="search-wrapper">
        <input
          type="text"
          [formControl]="searchControl"
          placeholder="Type to search hospitals..."
          class="search-input"
          autocomplete="off" />
        <mat-icon *ngIf="isSearching" class="search-spinner">sync</mat-icon>
      </div>

      <!-- Search results dropdown -->
      <div class="search-results" *ngIf="searchResults.length > 0">
        <div
          *ngFor="let hospital of searchResults"
          class="search-result-item"
          [class.pending]="hospital.isPending"
          (click)="!hospital.isPending && selectSearchResult(hospital)">
          <div class="result-info">
            <span class="result-name">{{ hospital.practiceName }}</span>
            <span class="result-code">{{ hospital.hospitalCode }}</span>
          </div>
          <span *ngIf="hospital.isPending" class="result-pending-badge">Pending</span>
        </div>
      </div>
    </div>

    <!-- Selected hospital chip -->
    <div *ngIf="selectedNewHospital" class="selected-chip">
      Selected: {{ selectedNewHospital.practiceName }}
      <span class="chip-code">{{ selectedNewHospital.hospitalCode }}</span>
    </div>

    <a class="back-link" (click)="backToExisting()" *ngIf="grantedSites.length > 0">
      &larr; Back to existing sites
    </a>

    <button
      class="confirm-btn"
      [disabled]="!selectedNewHospital || isSubmitting"
      (click)="confirmNewSite()">
      {{ isSubmitting ? 'Submitting...' : 'Request Additional Hospital Site' }}
    </button>
  </div>

  <!-- CONFIRMATION MESSAGE -->
  <div *ngIf="confirmationMessage" class="confirmation-section">
    <mat-icon class="confirmation-icon">check_circle</mat-icon>
    <p class="confirmation-message">{{ confirmationMessage }}</p>
    <button class="confirm-btn" (click)="close()">Close</button>
  </div>
</div>
